import { Navigate } from "react-router-dom";
import React from "react";
import * as AuthService from "../../services/auth.service";
import {Box, Alert} from "@mui/joy";

interface ProtectedRouteProps {
  component: React.JSX.Element;
  allowedRole: Array<string>;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({component, allowedRole,}) => {
  const user = AuthService.getCurrentUser();

  if (!user) {
    return <Navigate to="/login"/>;
  } else if (!user.roles?.some((item: string) => allowedRole.includes(item))) {
     return (
      <>
        <Box
          className="App"
          sx={{
            px: { xs: 2},
            pt: { xs: 'calc(12px + var(--Header-height))' },
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            minWidth: 0,
            height: '100dvh',
            overflow: "auto"
          }}
        >
          <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
            <Alert color="danger">
              <h1>Usted no tiene permisos para ver esta seccion.</h1>
            </Alert>
          </Box>
        </Box>
      </>
     );
  }

  return component; // return the right page if user is cleared.
};

export default ProtectedRoute;